export default __webpack_public_path__ + "static/media/helpdesk.03bc061e.png";